__turbopack_context__.v({
  "showMoreButton": "TechStack-module-scss-module__RlnNka__showMoreButton",
  "techBadge": "TechStack-module-scss-module__RlnNka__techBadge",
  "techStack": "TechStack-module-scss-module__RlnNka__techStack",
});
